import { useState } from "react";
import TestActionsModal from "../modal/TestActionsModal";

const TestCard = ({ homework, themes }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    if (!homework) {
        console.error("Ошибка: TestCard получил undefined homework");
        return null;
    }

    // Находим тему, соответствующую `homework.theme_id`
    const theme = themes.find((t) => t.id === homework.theme_id);

    return (
        <>
            <div
                className="relative shrink-0 basis-[278px] bg-lavender-8 rounded-2xl p-2 cursor-pointer hover:shadow-lg transition-shadow"
                onClick={() => setIsModalOpen(true)}
            >
                <div className="py-4 px-2 leading-5">
                    <h4 className="font-semibold">
                        {homework.title?.trim() ? homework.title : theme?.title || "Без названия"}
                    </h4>
                    <p className="text-gray-600">{homework.description || "Описание отсутствует"}</p>
                </div>
            </div>

            {isModalOpen && (
                <TestActionsModal
                    isOpen={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    homework={homework} // Передаем именно homework
                />
            )}
        </>
    );
};

export default TestCard;
